import { Button } from "@/components/ui/button";
import { Lock, UserX } from "lucide-react";
import { Link } from "react-router-dom";

interface NotFoundStateProps {
  isPrivate?: boolean;
}

const NotFoundState = ({ isPrivate = false }: NotFoundStateProps) => {
  const Icon = isPrivate ? Lock : UserX;
  return (
    <div className="rounded-3xl border border-border/60 bg-card py-20 px-6 flex items-center justify-center">
      <div className="text-center max-w-md">
        <div className="relative inline-flex mb-5">
          <div
            aria-hidden
            className="absolute -inset-4 rounded-full blur-2xl opacity-50"
            style={{ background: "hsl(var(--primary) / 0.25)" }}
          />
          <Icon className="relative h-12 w-12 text-muted-foreground" />
        </div>
        <h2 className="text-xl font-semibold text-foreground mb-2">
          {isPrivate ? "This profile is private" : "Researcher not found"}
        </h2>
        <p className="text-muted-foreground mb-6">
          {isPrivate
            ? "This researcher has chosen to keep their profile private."
            : "The researcher you're looking for doesn't exist or has been removed."}
        </p>
        <div className="flex items-center justify-center gap-2">
          <Button asChild variant="outline">
            <Link to="/explore">Explore researchers</Link>
          </Button>
          <Button onClick={() => window.history.back()}>Go back</Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundState;
